<template>
  <b-modal id="modal-incidente-otro" size="lg" :no-close-on-backdrop="true" :no-close-on-esc="true" v-model="mostrarModal" dialog-class="modal-dialog-scrollable" v-if="mostrarModal" @close="handleModalClose">
    <template slot="modal-title">
      <h5 class="mb-0">{{ incidenteOtroModel.nombreLocalVotacion }}</h5>
      <h5 class="mb-0">
        <small>{{ incidenteOtroModel.direccionLocalVotacion }}</small>
      </h5>
      <h5 class="mb-0">
        <small class="text-muted">{{ incidenteOtroModel.nombreRegion }} / {{ incidenteOtroModel.nonbreSubRegion }}</small>
      </h5>
    </template>
    
      <div v-if="cargando" class="text-center py-8">
        <i class="fa fa-spinner fa-spin fa-2x text-muted"></i>
      </div>
      <b-form v-else id="frm-detalle-incidente-otro">

      <div class="d-flex align-items-center mb-3">
        <span class="font-weight-bold mr-3">Estado</span>
        <span class="label label-inline label-lg" :class="claseEstado">{{ etiquetaEstado }}</span>
      </div>
      <div class="table-responsive mb-3">
        <table class="table table-bordered table-vertical-center mb-0">
          <tbody>
          <tr v-if="horaEventoActo">
            <td style="width: 180px;">{{ horaEventoActo }}</td>
            <td>
              Mesa {{ incidenteOtroModel.numeroMesa || '-' }}
            </td>
            <td style="width: 180px;">Incidente ocurrido</td>
          </tr>

            <tr v-for="(evento, idx) in historialAtencion" :key="idx">
              <td style="width: 180px;">{{ evento.fecha }}</td>
              <td>
                <template v-if="evento.esPropio">
                  <b><i class="fa fa-user" style="font-size: 1.0rem;"></i> Yo, </b>
                </template>
                {{ evento.usuario }}
              </td>
              <td style="width: 180px;">{{ evento.accion }}</td>
            </tr>
            <tr v-if="!historialAtencion.length">
              <td colspan="3" class="text-muted">Aún no ha sido tomado en atención.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="esIni || esFin" class="form-group mb-0">
        <div class="d-flex align-items-center mb-2">
          <label class="font-weight-bold mb-0">Observaciones de atención</label>
          <button v-if="esAdm && esFin && !editandoObservacion" type="button"
                  class="btn btn-icon btn-xs btn-light-primary ml-2"
                  title="Editar observación" @click.prevent="habilitarEdicionObservacion">
            <i class="fa fa-pencil-alt"></i>
          </button>
        </div>
        <textarea class="form-control" rows="3" v-model="observacionAtencion"
                  :disabled="!puedeEditarObservacion"
                  placeholder="Opcional. Registre lo actuado o el resultado de la atención."></textarea>
      </div>
      <button v-if="esAdm && (esIni || editandoObservacion)" type="button" class="btn btn-success mt-3" :disabled="guardando" @click.prevent="finalizarAtencion">
            <i class="fa fa-check mr-1"></i> {{ esFin ? "Guardar observación" : "Finalizar atención" }}
          </button>
      <hr />

      <div class="form-row">
        <div class="form-group col-md-4 mb-3">
          <label class="font-weight-bold">Turno</label>
          <b-form-input :value="incidenteOtroModel.turno ? 'Turno ' + incidenteOtroModel.turno : '-'" disabled></b-form-input>
        </div>
        <div class="form-group col-md-4 mb-3">
          <label class="font-weight-bold">Fecha y hora</label>
          <b-form-input :value="horaEventoActo" disabled></b-form-input>
        </div>
        <div class="form-group col-md-4 mb-3">
          <label class="font-weight-bold">Nro. Mesa</label>
          <b-form-input :value="incidenteOtroModel.numeroMesa || '-'" disabled></b-form-input>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-6 mb-3">
          <label class="font-weight-bold">Tipo de incidencia</label>
          <b-form-input :value="incidenteOtroModel.tipoIncidenteParamDescripcion || '-'" disabled></b-form-input>
        </div>
        <div class="form-group col-md-6 mb-3">
          <label class="font-weight-bold">Subtipo</label>
          <b-form-input :value="incidenteOtroModel.subtipoIncidenteParamDescripcion || '-'" disabled></b-form-input>
        </div>
      </div>

      <div class="form-group mb-3">
        <label class="font-weight-bold">Ubicación</label>
        <b-form-input :value="incidenteOtroModel.ubicacion || '-'" disabled></b-form-input>
      </div>

      <div class="form-group mb-3">
        <label class="font-weight-bold">Descripción</label>
        <textarea class="form-control" :value="incidenteOtroModel.descripcion || incidenteOtroModel.descripcionActo || ''" disabled rows="4"></textarea>
      </div>

      <div class="form-group mb-3">
        <label class="font-weight-bold">Evidencia (fotografías)</label>
        <div v-if="incidenteOtroModel.imagenes && incidenteOtroModel.imagenes.length">
          <CoolLightBox :items="incidenteOtroModel.coolboxImages" :index="incidenteOtroModel.coolboxIndex" :useZoomBar="true" :slideshow="true" @close="incidenteOtroModel.coolboxIndex = null"> </CoolLightBox>
          <div class="d-flex flex-wrap">
            <div v-for="(imagen, imageIndex) in incidenteOtroModel.imagenes" :key="imagen.procesoElectoralMultimediaImagenId || imageIndex"
                 class="mr-2 mb-2 detalle-incidente-thumb" @click="incidenteOtroModel.coolboxIndex = imageIndex" style="cursor:pointer;">
              <img :src="apiResource(imagen.rutaArchivoThumb || imagen.rutaArchivo)" alt="Evidencia" />
            </div>
          </div>
        </div>
        <span v-else class="text-muted">Sin evidencia</span>
      </div>

     
    </b-form>
    <template slot="modal-footer">
      <div class="d-flex justify-content-between w-100">
        <div>

        </div>
        <div>
          <button v-if="esAdm && esPen" type="button" class="btn btn-primary mr-2" :disabled="guardando || cargando" @click.prevent="tomarAtencion">
            <i class="fa fa-play mr-1"></i> Tomar atención
          </button>
          <button type="button" class="btn btn-secondary" @click.prevent="handleModalClose()"><i class="fa fa-times mr-1"></i> Cerrar</button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<style>
.detalle-incidente-thumb img {
  height: 100px;
  width: 100px;
  object-fit: cover;
  border: 1px solid #e4e6ef;
  border-radius: 4px;
  background: #fff;
}
.detalle-incidente-thumb:hover img {
  border-color: #3699ff;
  box-shadow: 0 0 0 2px rgba(54, 153, 255, 0.25);
}
</style>

<script>
import moment from "moment";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

export default {
  name: "modal-incidente-otro",
  components: { CoolLightBox },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    incidenteOtro: {
      type: Object,
    },
  },
  data: () => ({
    mostrarModal: true,
    incidenteOtroModel: {},
    horaEventoActo: null,
    observacionAtencion: "",
    editandoObservacion: false,
    guardando: false,
    cargando: false,
  }),
  computed: {
    esAdm() {
      return this.$session.get("CodigoRol") === "ADM";
    },
    estado() {
      return (this.incidenteOtroModel.estadoAtencion || "PEN").toString().trim().toUpperCase();
    },
    esPen() {
      return this.estado === "PEN";
    },
    esIni() {
      return this.estado === "INI";
    },
    esFin() {
      return this.estado === "FIN";
    },
    puedeEditarObservacion() {
      return this.esAdm && (this.esIni || this.editandoObservacion);
    },
    etiquetaEstado() {
      if (this.esIni) return "En atención";
      if (this.esFin) return "Atendido";
      return "Pendiente";
    },
    claseEstado() {
      if (this.esIni) return "label-light-primary";
      if (this.esFin) return "label-light-success";
      return "label-light-warning";
    },
    historialAtencion() {
      const filas = [];
      const usuarioActualId = Number(this.$session.get("UsuarioId"));
      if (this.incidenteOtroModel.fechaRegistro || this.incidenteOtroModel.usuarioRegistroId) {
        filas.push({
          fecha: this.formatoFecha(this.incidenteOtroModel.fechaRegistro),
          usuario: this.incidenteOtroModel.usuarioRegistroNombre || "—",
          accion: "Incidente reportado",
          esPropio: Number(this.incidenteOtroModel.usuarioRegistroId) === usuarioActualId,
        });
      }
      if (this.incidenteOtroModel.fechaInicioAtencion) {
        filas.push({
          fecha: this.formatoFecha(this.incidenteOtroModel.fechaInicioAtencion),
          usuario: this.incidenteOtroModel.usuarioInicioAtencionNombre || "—",
          accion: "Inicio de atención",
          esPropio: Number(this.incidenteOtroModel.usuarioInicioAtencionId) === usuarioActualId,
        });
      }
      if (this.incidenteOtroModel.fechaFinAtencion) {
        filas.push({
          fecha: this.formatoFecha(this.incidenteOtroModel.fechaFinAtencion),
          usuario: this.incidenteOtroModel.usuarioFinAtencionNombre || "—",
          accion: "Atención finalizada",
          esPropio: Number(this.incidenteOtroModel.usuarioFinAtencionId) === usuarioActualId,
        });
      }
      return filas;
    },
  },
  methods: {
    formatoFecha(valor) {
      if (!valor) return "";
      return moment(String(valor)).format("DD/MM/YYYY h:mm A");
    },
    aplicarAtencion(data) {
      if (!data) return;
      this.incidenteOtroModel.estadoAtencion = data.estadoAtencion;
      this.incidenteOtroModel.fechaInicioAtencion = data.fechaInicioAtencion;
      this.incidenteOtroModel.usuarioInicioAtencionId = data.usuarioInicioAtencionId;
      this.incidenteOtroModel.usuarioInicioAtencionNombre = data.usuarioInicioAtencionNombre;
      this.incidenteOtroModel.fechaFinAtencion = data.fechaFinAtencion;
      this.incidenteOtroModel.usuarioFinAtencionId = data.usuarioFinAtencionId;
      this.incidenteOtroModel.usuarioFinAtencionNombre = data.usuarioFinAtencionNombre;
      this.incidenteOtroModel.observacionAtencion = data.observacionAtencion;
      this.observacionAtencion = data.observacionAtencion || "";
    },
    armarImagenes(imagenes) {
      const lista = imagenes || [];
      this.incidenteOtroModel.imagenes = lista;
      this.incidenteOtroModel.coolboxIndex = null;
      this.incidenteOtroModel.coolboxImages = lista.map((x) => ({
        description: this.incidenteOtroModel.descripcion || this.incidenteOtroModel.descripcionActo || "",
        thumb: this.apiResource(x.rutaArchivoThumb || x.rutaArchivo),
        src: this.apiResource(x.rutaArchivo),
      }));
    },
    aplicarDetalle(data) {
      const cabecera = data.cabecera || {};
      const incidente = data.incidente || {};
      this.incidenteOtroModel = Object.assign({}, this.incidenteOtroModel, cabecera, incidente);
      if (incidente.horaEvento && !this.incidenteOtroModel.horaEventoActo) {
        this.incidenteOtroModel.horaEventoActo = incidente.horaEvento;
      }
      this.observacionAtencion = this.incidenteOtroModel.observacionAtencion || "";
      this.horaEventoActo = this.formatoFecha(this.incidenteOtroModel.horaEventoActo || this.incidenteOtroModel.horaEvento);
      this.armarImagenes(this.incidenteOtroModel.imagenes);
    },
    cargarDetalle() {
      const id = this.incidenteOtro && this.incidenteOtro.localVotacionFichaIncidenteId;
      if (!id) return;
      const estadoLista = (this.incidenteOtro.estadoAtencion || "PEN").toString().trim().toUpperCase();
      this.cargando = true;
      this.$http
        .get(this.apiRoute("Incident", "GetLocalVotacionIncidenteOtroById"), {
          params: { LocalVotacionFichaIncidenteId: id },
        })
        .then((response) => {
          this.cargando = false;
          if (this.procesarRespuestaErrorDefecto(response)) return;
          this.aplicarDetalle(response.body.data);
          const estadoApi = (this.incidenteOtroModel.estadoAtencion || "PEN").toString().trim().toUpperCase();
          if (estadoApi !== estadoLista) {
            this.$bvToast.toast("El estado de este incidente cambió desde que se cargó el listado.", {
              title: "Incidente actualizado",
              autoHideDelay: 5000,
              variant: "info",
              solid: true,
            });
            this.$emit("onSave", this.incidenteOtroModel);
          }
        }, (error) => {
          this.cargando = false;
          this.mostrarMensajeExcepcionVueResource(error);
        });
    },
    atender(accion) {
      this.guardando = true;
      const model = {
        localVotacionFichaIncidenteId: this.incidenteOtroModel.localVotacionFichaIncidenteId,
        accion: accion,
        observacionAtencion: this.observacionAtencion || "",
      };
      this.$http.post(this.apiRoute("Incident", "AtenderLocalVotacionIncidenteOtro"), model).then((response) => {
        this.guardando = false;
        if (this.procesarRespuestaErrorDefecto(response)) {
          if (response.body && response.body.data) {
            this.aplicarAtencion(response.body.data);
            this.$emit("onSave", response.body.data);
          }
          return;
        }
        this.aplicarAtencion(response.body.data);
        this.editandoObservacion = false;
        this.$emit("onSave", response.body.data);
        this.$bvToast.toast(response.body.message || "Operación realizada.", {
          title: "Atención de incidente",
          autoHideDelay: 4000,
          variant: "success",
          solid: true,
        });
      }, (error) => {
        this.guardando = false;
        this.mostrarMensajeExcepcionVueResource(error);
      });
    },
    tomarAtencion() {
      this.atender("INI");
    },
    finalizarAtencion() {
      this.atender("FIN");
    },
    habilitarEdicionObservacion() {
      this.editandoObservacion = true;
    },
    handleModalClose: async function(event) {
      if (event) {
        event.preventDefault();
      }
      this.mostrarModal = false;
    },
  },
  watch: {
    mostrarModal: function(newValue) {
      this.$emit("input", newValue);
    },
  },
  mounted: function() {
    this.mostrarModal = this.value;
    this.incidenteOtroModel = Object.assign({}, this.incidenteOtro);
    this.observacionAtencion = this.incidenteOtroModel.observacionAtencion || "";
    this.horaEventoActo = this.formatoFecha(this.incidenteOtroModel.horaEventoActo);
    this.cargarDetalle();
  },
  destoyed: function() {},
};
</script>
